import React, { useState } from "react";

export default function BuildYourOwnAI() {
  const [action, setAction] = useState("");
  const [learn, setLearn] = useState("");
  const [sentence, setSentence] = useState("");
  const [example, setExample] = useState("");
  const [gif, setGif] = useState("");

  const examples = {
    "draw|images": {
      sentence: "🎨 My AI robot learns to draw pictures by looking at images!",
      example: "🖌️ Like Google's AI that turns doodles into art.",
      gif: "https://media.itsnicethat.com/original_images/58edefb47fa44ce722000791.gif",
    },
    "dance|voice": {
      sentence: "💃 My AI robot learns to dance to music by listening to voices!",
      example: "🎵 Like Boston Dynamics’ dancing robots!",
      gif: "https://mymodernmet.com/wp/wp-content/uploads/2021/01/boston-dynamics-do-you-love-me-robot-dance-03.gif",
    },
    "talk|watching": {
      sentence: "🗣️ My AI robot learns to talk by watching people talking!",
      example: "👀 Learning emotions & conversations like a smart bot!",
      gif: "https://cdn.dribbble.com/userupload/23448740/file/original-f81f54f24062659d45df7da4940835f1.gif",
    },
    "play|mistakes": {
      sentence: "🎮 My AI robot learns to play games by making mistakes!",
      example: "🤖 Like AlphaGo improving after every game.",
      gif: "https://s.yimg.com/ny/api/res/1.2/7YVNiFfKmjSIUwc34x9hLg--/YXBwaWQ9aGlnaGxhbmRlcjt3PTk2MDtoPTU0MA--/https://media.zenfs.com/en-US/homerun/quartz.com/d11d349afc1fa0839eb601625b2954c1",
    },
    "sing|listening": {
      sentence: "🎶 My AI robot learns to sing songs by listening to them!",
      example: "🎤 Like Alexa or Siri using sound data!",
      gif: "https://i.pinimg.com/originals/7a/2c/61/7a2c61ac65740746de5d5126d410d359.gif",
    },
    "solve|patterns": {
      sentence: "🧩 My AI robot learns to solve puzzles by following patterns!",
      example: "🔁 Like smart robots solving cubes!",
      gif: "https://i.makeagif.com/media/2-06-2016/EXzri1.gif",
    },
  };

  const buildAI = () => {
    const key = `${action}|${learn}`;
    if (examples[key]) {
      setSentence(examples[key].sentence);
      setExample(examples[key].example);
      setGif(examples[key].gif);
    } else {
      setSentence("❌ Oops! Pick one from each box to build your AI.");
      setExample("");
      setGif("");
    }
  };

  const styles = {
    container: {
      maxWidth: "800px",
      margin: "30px auto",
      padding: "30px",
      borderRadius: "30px",
      background: "linear-gradient(to right,rgb(216, 253, 52),rgb(63, 228, 240))",
      boxShadow: "0 0 20px rgba(0,0,0,0.15)",
      fontFamily: "'Comic Sans MS', cursive",
      textAlign: "center",
    },
    title: {
      fontSize: "2.8rem",
      color: "#D81B60",
      marginBottom: "20px",
    },
    label: {
      fontSize: "1.3rem",
      color: "#4A148C",
      marginTop: "20px",
      marginBottom: "5px",
    },
    select: {
      padding: "12px",
      fontSize: "1rem",
      borderRadius: "12px",
      border: "3px solid #BA68C8",
      background: "#F3E5F5",
      color: "#4A148C",
      width: "70%",
      marginBottom: "20px",
    },
    button: {
      marginTop: "20px",
      padding: "14px 30px",
      fontSize: "1.2rem",
      background: "linear-gradient(to right, #FF9800, #F06292)",
      color: "white",
      border: "none",
      borderRadius: "20px",
      cursor: "pointer",
      boxShadow: "2px 2px 10px rgba(0,0,0,0.2)",
    },
    outputBox: {
      marginTop: "30px",
      padding: "20px",
      background: "#FFF3E0",
      border: "2px dashed #FF7043",
      borderRadius: "20px",
      fontSize: "1.2rem",
      color: "#BF360C",
    },
    exampleBox: {
      marginTop: "15px",
      padding: "15px",
      background: "#DCEDC8",
      border: "2px dashed #8BC34A",
      borderRadius: "20px",
      color: "#33691E",
    },
   gif: {
  display: "block",         // makes margin:auto work
  margin: "20px auto",      // centers horizontally
  maxWidth: "100%", 
  borderRadius: "16px",
  border: "5px solid #4FC3F7",
  boxShadow: "0 0 12px rgba(0,0,0,0.2)",
}

  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🤖 Build Your Own AI!</h1>

      <div>
        <label style={styles.label}>🧠 My AI robot learns to...</label>
        <br />
        <select style={styles.select} value={action} onChange={(e) => setAction(e.target.value)}>
          <option value="">-- Choose an action --</option>
          <option value="draw">Draw pictures</option>
          <option value="dance">Dance to music</option>
          <option value="talk">Talk to people</option>
          <option value="play">Play games</option>
          <option value="sing">Sing songs</option>
          <option value="solve">Solve puzzles</option>
        </select>
      </div>

      <div>
        <label style={styles.label}>📚 By...</label>
        <br />
        <select style={styles.select} value={learn} onChange={(e) => setLearn(e.target.value)}>
          <option value="">-- Choose how it learns --</option>
          <option value="images">Looking at images</option>
          <option value="voice">Listening to voices</option>
          <option value="watching">Watching people talk</option>
          <option value="mistakes">Learning from mistakes</option>
          <option value="listening">Listening to songs</option>
          <option value="patterns">Following patterns</option>
        </select>
      </div>

      <button style={styles.button} onClick={buildAI}>✨ Show My AI!</button>

      {sentence && <div style={styles.outputBox}>{sentence}</div>}
      {example && <div style={styles.exampleBox}>{example}</div>}
      {gif && <img style={styles.gif} src={gif} alt="AI Gif" />}
    </div>
  );
}
